import React, {useEffect, useState} from "react";
import Loading from "../../general/Loading";
import {Button, Col, Row} from "react-bootstrap";
import {FormattedMessage} from "react-intl";
import {getNonComplianceCauseToRegulationMap, getNonCompliances} from "../../../rest/nonCompliance";
import {AddNonComplianceModal} from "./noncompliance/AddNonComplianceModal";
import {NonComplianceList} from "./noncompliance/NonComplianceList";
import {hasPermission, isIEFPUser} from "../../../authentication/authenticationHelper";
import {CandidatureState} from "../../../models/CandidatureState";
import {useGlobalContext} from "../../../context";

export function NonComplianceTab({candidature}) {
    const [nonComplianceCauseToRegulationMap, setNonComplianceCauseToRegulationMap] = useState(null);
    const [nonCompliances, setNonCompliances] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [addModalShow, setAddModalShow]  = useState(false);
    const [modalSubmitted, setModalSubmitted] = useState(false);
    const { accessInfo } = useGlobalContext();

    const fetchData = async () => {
        try {
            setModalSubmitted(false);
            setLoading(true);
            const [{ data: nonComplianceList }, { data: causeMap }] = await Promise.all([
                getNonCompliances(candidature.externalId),
                getNonComplianceCauseToRegulationMap(' ')
            ]);
            setNonCompliances(nonComplianceList);
            setNonComplianceCauseToRegulationMap(causeMap);
            setLoading(false);
        } catch (error) {
            setError(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [modalSubmitted]);

    if (loading) {
        return <Loading />;
    }



    return (
        <>
            <Row>
                <Col className='justify-content-end d-flex'>
                    {isIEFPUser() && candidature.state === CandidatureState.FULLY_APPROVED &&
                    hasPermission('MANAGE_NONCOMPLIANCE', accessInfo) && (
                    <Button variant='outline-primary' onClick={ () => setAddModalShow(true)}>
                        <FormattedMessage id='candidatureTabs.oversight.tabs.noncompliance.add' />
                    </Button>
                    )}
                </Col>
            </Row>
            <Row>
                <Col>
                    <NonComplianceList
                        nonCompliances={nonCompliances}
                        nonComplianceCauseToRegulationMap={nonComplianceCauseToRegulationMap}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <AddNonComplianceModal
                        show={addModalShow}
                        setShow={setAddModalShow}
                        candidature={candidature}
                        nonComplianceCauseToRegulationMap={nonComplianceCauseToRegulationMap}
                        onSubmitCallback={() => setModalSubmitted(true)}

                    />
                </Col>
            </Row>

        </>
    );
}